import { InfoRequestTask } from '../info-request-task/info-request-task.model';

export class InfoRequestCommentTask extends InfoRequestTask {
    commentsCount: number;
}
